<button class="zx-mobile-menu-button" mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu class="zx-menu" #menu="matMenu">
  @for (item of items; track item) {
    <button mat-menu-item (click)="item.clicked.emit(subject)">
      <mat-icon>{{item.iconName}}</mat-icon>
      {{item.tooltip}}
    </button>
  }
</mat-menu>
@for (item of items; track item) {
  <button class="zx-desktop-button" mat-icon-button (click)="item.clicked.emit(subject)"
    [matTooltip]="item.tooltip">
    <mat-icon>{{item.iconName}}</mat-icon>
  </button>
}
